/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatchedProviderBookingCreate } from '../models/PatchedProviderBookingCreate';
import type { ProviderBookingValidate } from '../models/ProviderBookingValidate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BookingRequestsValidateService {

    /**
     * @returns ProviderBookingValidate
     * @throws ApiError
     */
    public static bookingRequestsValidatePartialUpdate({
        requestBody,
    }: {
        requestBody?: PatchedProviderBookingCreate,
    }): CancelablePromise<ProviderBookingValidate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/booking-requests-validate/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
